import { useContentAiGetContentByKey } from '@mi-front/api-v2';
import { getApiErrorHttpStatus } from '@mi-front/core';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { useFragment } from '../../hooks/useFragment';
import { CreateFragmentContent } from './CreateFragmentContent';
import { FragmentContentLink } from './FragmentContentLink';

/**
 * Content AI tab for a fragment: create content if none exists for this key,
 * otherwise link to the existing Content AI content.
 * Retry on 404 is already skipped by the global QueryClient default.
 */
export function FragmentContentAiView() {
  const { fragment } = useFragment();
  const result = useContentAiGetContentByKey(`FRAGMENT:${fragment.id}`);

  if (getApiErrorHttpStatus(result.error) === 404) {
    return <CreateFragmentContent id={fragment.id} />;
  }

  return <QueryView query={result}>{(data) => <FragmentContentLink content={data} />}</QueryView>;
}
